import ConfigService from "./ConfigService";
import HttpService from "./HttpService";

import AuthUser from "../models/AuthUser";




export default class getAuthResourceServiceHost
{
    constructor(authResourceDomain)
    {
        this.configService = new ConfigService();
        this.domain = authResourceDomain || this.configService.getAuthResourceServiceHost();
    }



    async fetchVersion(token)
    {
        const path = "/api/admin/version";
        var response = await HttpService.get(this.domain, path, token);
        return response;   
    }

    async pingCore(token) 
    {
        const path = "/api/admin/ping";
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }
    
  


      async getScopesByRoles(roles, token)
      {
        var path = "/api/resources/app/" + this.configService.getAppPrefix() + "/gcauthscope/role/{firstrole}".replace("{firstrole}", roles[0]);
        var additionalRoles = roles.splice(1);
        if (additionalRoles.length > 0)
        {
            var queryString = additionalRoles.map((v, i) => "role=" + v).join("&");
            path = path + "?" + queryString;
        }
        // any additional roles are added as query string values
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }


      async getAppUsers(gcid, token)
      {
        var path = "/api/users/app/itrace/gcid/" + gcid + "/gcauthclient";
        var response = await HttpService.get(this.domain, path, token);
        if (!response.hasError)
        {
          var result = response.dataResult.map((u) => {
            return { ...u, clientId: this.configService.getShortUid(gcid, u.clientId) };
          });
          response.dataResult = result;
        }
        return response;
      }

      /* NOT USED - see appsettings/config for itrace roles
      async getAppRoles(token)
      {
        var path = "/api/resources/app/itrace/gcauthrole";
        var response = await HttpService.get(this.domain, path, token);
        return response;
      }
      */

      async postAppUser(user, gcid, token)
      {
        var path = "/api/users/app/itrace/gcid/" + gcid + "/gcauthclient";
        // note that we add the app and the gcid to the end of the user so that the same user name
        // can exist in multiple gcids and/or apps.
        user.addSuffix();
        //user.clientId = user.clientId + "." + user.app + "." + user.gcid;
        var postObj = JSON.stringify(user);
        var response = await HttpService.postJson(this.domain, path, token, postObj);
        return response;
      }

      async deleteAppUser(userToDeleteId, gcid, token)
      {
        var fullUid = AuthUser.toFullUid(this.configService.getAppPrefix(), gcid, userToDeleteId);
        var path = "/api/users/app/itrace/gcid/" + gcid + "/gcauthclientdeleterequest/id/" + fullUid;

        var response = await HttpService.postJson(this.domain, path, token, JSON.stringify(fullUid));
        return response;
      }

      async postAppUserEnabledFlag(userToEnableId, newFlagStatusBool, gcid, token)
      {
        var fullUid = AuthUser.toFullUid(this.configService.getAppPrefix(), gcid, userToEnableId);
        var path = "/api/users/app/itrace/gcid/" + gcid + "/gcauthclientenabledflagrequest/id/" + fullUid + "/enabled/" + newFlagStatusBool.toString();
        var postObj = JSON.stringify(newFlagStatusBool);
        var response = await HttpService.postJson(this.domain, path, token, postObj);
        return response;
      }

}